import React from "react";
import { SpotlightLogoGrayscaleSvg } from "component-library";
import { FMLogoDarkIcon } from "assets";

interface IPerformerNameBarProps {
  fullName: string;
  userType: string;
  logo: "filmmakers" | "spotlight";
}

const LOGO_MAP = {
  spotlight: SpotlightLogoGrayscaleSvg,
  filmmakers: FMLogoDarkIcon,
};

export const PerformerNameBar: React.FC<
  React.PropsWithChildren<IPerformerNameBarProps>
> = ({ fullName, userType, logo }) => {
  return (
    <div className="c-paper-cv__performer-name-bar">
      <div className="c-paper-cv__performer-name">{fullName}&nbsp;</div>
      <div className="c-paper-cv__performer-type">{userType}</div>
      {/* Need to set image and alter here so that they preload in JS */}

      <div
        className={`c-paper-cv__logo ${logo}`}
        style={{
          backgroundImage: `url(${LOGO_MAP[logo]}`,
        }}
      ></div>
    </div>
  );
};
